import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { getParameterByName } from '../../helpers/window-helper';
import AuthService from '../../services/AuthService';
import { RouterPaths } from '../../constants/routes';
import { LoadingFullScreen } from '../../components/Loading/Loading';
import { getUser } from '../../services/HatApiService';
import { RegistrationUserBody, RegistrationUserState } from '../../interfaces/registration';
import { postProfile, signupUser } from '../../services/RegistrationService';

interface SignUpAuthProps {
  path?: string;
  exact?: boolean;
  default?: boolean;
}

const RegistrationAuthenticateHatPage: React.FC<SignUpAuthProps> = () => {
  const history = useHistory();

  async function getUserProfile() {
    try {
      if (AuthService.getHatname()) {
        await getUser();
      }
    } catch (error) {
      throw Error('Login failed');
    }
  }

  async function signup(savedUser: RegistrationUserState) {
    const body: RegistrationUserBody = {
      firstName: savedUser.firstName,
      lastName: savedUser.lastName,
      email: savedUser.email,
      username: savedUser.username,
      termsAgreed: savedUser.termsAgreed,
    };

    if (savedUser.company) {
      body.company = savedUser.company;
    }

    try {
      await signupUser(body);

      localStorage.setItem('new_signup', 'true');
    } catch (error) {
      throw Error('Registration failed');
    }
  }

  const signupSuccess = () => {
    sessionStorage.removeItem('signup');
    history.replace(RouterPaths.dashboard);
  };

  const signupError = () => {
    sessionStorage.removeItem('signup');
    history.replace('/signup/error');
  };

  const registerOrLogin = async (savedUser: RegistrationUserState) => {
    try {
      await signup(savedUser);
    } catch (e) {
      const token = getParameterByName('token');

      if (token) {
        AuthService.login(token);
      }

      if (AuthService.loggedIn()) {
        await getUserProfile();
      } else {
        AuthService.logout();
        sessionStorage.removeItem('signup');
        throw Error('Registration and Login failed');
      }
    }
  };

  const postUserProfile = async (savedUser: RegistrationUserState, hatUrl: string) => {
    try {
      await postProfile(savedUser, hatUrl);
    } catch (e) {
      // Catching the error here as posting the user profile to the HAT
      // is optional and don't want to affect the registration.
    }
  };

  const validateStoredDetailsAndProcessRequests = async () => {
    const token = getParameterByName('token');
    const error = getParameterByName('error');
    const userJson = sessionStorage.getItem('signup');

    if (error || !userJson) {
      signupError();
      return;
    }

    if (!token) {
      return;
    }

    AuthService.login(token);

    if (userJson) {
      const savedUser: RegistrationUserState = JSON.parse(userJson);

      try {
        await registerOrLogin(savedUser);
        await postUserProfile(savedUser, AuthService.getHatname(token) || '');

        signupSuccess();
      } catch (e) {
        signupError();
      }
    }
  };

  useEffect(() => {
    validateStoredDetailsAndProcessRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ minHeight: '100vh' }}>
      <LoadingFullScreen />
    </div>
  );
};

export default RegistrationAuthenticateHatPage;
